export default __webpack_public_path__ + "static/media/warning.bd6906fa.svg";